import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://api.mysafari.co.tz/api",
  timeout: 180000,
  headers: { Accept: "application/json", "Content-Type": "application/json" },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const res = await axios.post(
          "https://api.mysafari.co.tz/api/verify-otp",
          { phone_number: "255715000011", otp: "8261" },
        );
        const token =
          res.data.data?.access_token ?? res.data.user?.access_token;
        if (token) {
          localStorage.setItem("access_token", token);
          originalRequest.headers["Authorization"] = `Bearer ${token}`;
          return axiosInstance(originalRequest);
        }
      } catch (_) {}
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
